<tui-scrollbar class="navigation-wrapper">
  <nav class="navigation">
    <ng-container *ngFor="let item of items">
      <ng-container *ngxPermissionsOnly="item.permissions || []">
        <a
          class="navigation-item"
          [routerLink]="item.link"
          [queryParams]="item.queryParams"
          routerLinkActive="navigation-item_active"
          (click)="item.action && item.action()"
        >
          <app-icon *ngIf="item.icon" class="navigation-item__icon" [size]="'18px'" [src]="item.icon"></app-icon>

          <div>
            <div class="navigation-item__title">
              {{ item.title | translate }}
            </div>
          </div>
        </a>
      </ng-container>
    </ng-container>
  </nav>
</tui-scrollbar>
